import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Grid, TextField, Card, CardContent } from "@material-ui/core";
import GoogleLogin from "react-google-login";
import Recaptcha from "react-recaptcha";
import { Formik } from "formik";
import { setDocEmail, setNextStage } from "../../reducers/documento";
//import isEmail from "../../utils/isEmail";
import Header from "./styles-forms/Header";

import useDidMountEffect from "../../hooks/useDidMountEffect";

import { signin, authGoogle } from "../../reducers/auth";
import Signup from "pages/Signup";
import Forgot from "./Forgot";

//import illustration1 from '../../assets/images/illustrations/pack1/authentication.svg';

// Empresa del catálogo público (Gestdoc.cl): solo sus trámites permiten continuar sin cuenta.
// Los flujos de empresas privadas (ALCSA, RESIT, ...) siguen pidiendo iniciar sesión.
const EMPRESA_PUBLICA = "6244804951372e00125f2b2f";

export default function ChooseAccount({ canGoBack, handleBack }) {
  const refSending = useRef(false);

  const dispatch = useDispatch();
  const { transaction, participant } = useParams();
  const emailDoc = useSelector(({ documento }) => documento.email);
  const isAuth = useSelector(({ auth }) => auth.token !== null);
  const emailUser = useSelector(({ auth }) => auth.email);
  const auth = useSelector(({ auth }) => auth);
  const documento = useSelector(({ documento }) => documento.documento);
  const gestores = useSelector(({ documento }) => documento.gestores);
  const { participants } = useSelector(({ documento }) => documento.documento);
  // eslint-disable-next-line
  const [email, setEmail] = useState("");
  const [verified, setVerified] = useState(false);

  const allowGuest = String((documento && documento.company) || "") === EMPRESA_PUBLICA;
  const [optionView, setOptionView] = useState(allowGuest ? "login" : "password");
  const [guestEmail, setGuestEmail] = useState("");
  const [guestError, setGuestError] = useState("");

  const continueAsGuest = (e) => {
    if (e) e.preventDefault();
    const value = guestEmail.trim();
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
      setGuestError("Ingresa un correo válido para enviarte el documento");
      return;
    }
    setGuestError("");
    dispatch(setDocEmail(value));
    createTransaction(value);
  };

  /*const handleInput = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (isEmail(value)) {
      dispatch(setDocEmail(value));
    } else {
      dispatch(setDocEmail(false));
    }
  };*/

  const responseGoogle = async (response) => {
    if (response.profileObj) {
      dispatch(authGoogle(response));
      //esperar el response.
      // dispatch(setDocEmail(response.profileObj.email));
      //createTransaction(response.profileObj.email);
    }
  };

  const responseGoogleFail = async (response) => {
    console.log(response);
  };

  const startDoc = (e) => {
    if (e) e.preventDefault();
    //createTransaction();
    if (!verified) executeCaptcha();
    else createTransaction();
  };

  let participantData = null;
  if (participant && documento) {
    participantData = participants.find((it) => it.id === participant);
  } else if (documento) {
    participantData = participants[0];
  }

  const createTransaction = (emailOpt = "") => {
    let participantDataCurrent = null;
    if (participant && documento) {
      participantDataCurrent = gestores.find((it) => it.id === participant);
    } else if (documento) {
      participantDataCurrent = gestores[0];
    }
    if (!refSending.current) {
      refSending.current = true;
    } else {
      return alert("Inicio de sesión en proceso");
    }
    dispatch(
      setNextStage(transaction, participantDataCurrent.current, {
        type: "sign_in",
        titleStage: participantData.next.name,
        notification: participantData.next["custom:notification"] === "true",
        value: emailOpt || email || emailDoc || emailUser,
      })
    );
  };

  // create a variable to store the component instance
  let recaptchaInstance;

  // manually trigger reCAPTCHA execution
  const executeCaptcha = function () {
    recaptchaInstance.execute();
  };

  // executed once the captcha has been verified
  // can be used to post forms, redirect, etc.
  const verifyCallback = function (response) {
    setVerified(true);
    startDoc();
  };

  useDidMountEffect(() => {
    if (isAuth) {
      createTransaction();
    }
    // eslint-disable-next-line
  }, [isAuth]);
  useDidMountEffect(() => {
    if (emailUser) {
      dispatch(setDocEmail(emailUser));
    }
    // eslint-disable-next-line
  }, [emailUser]);

  useEffect(() => {
    executeCaptcha();
    if (isAuth) {
      createTransaction();
    }
    // eslint-disable-next-line
  }, []);

  const loginError =
    auth.error && auth.error.response && auth.error.response.data && auth.error.response.data.message
      ? auth.error.response.data.message.message || "No pudimos iniciar sesión. Revisa tu correo y contraseña."
      : "";

  const passwordForm = (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}
      validate={(values) => {
        const errors = {};
        if (!values.email) {
          errors.email = "Ingresa tu correo";
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
          errors.email = "Correo electrónico inválido";
        }
        if (!values.password) {
          errors.password = "Ingresa tu contraseña";
        }
        return errors;
      }}
      onSubmit={async (values, actions) => {
        try {
          dispatch(signin(values));
        } catch (errors) {
          actions.setStatus(errors);
        }
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
        <form className="gd-login-form" onSubmit={handleSubmit}>
          <label className="gd-login-label" htmlFor="gd-login-email">
            Correo electrónico
          </label>
          <TextField
            id="gd-login-email"
            className="input_sign"
            variant="outlined"
            size="small"
            fullWidth
            type="email"
            placeholder="tu@correo.cl"
            name="email"
            autoComplete="email"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
          />
          {errors.email && touched.email && <span className="gd-login-error">{errors.email}</span>}

          <label className="gd-login-label" htmlFor="gd-login-password">
            Contraseña
          </label>
          <TextField
            id="gd-login-password"
            className="input_sign"
            variant="outlined"
            size="small"
            fullWidth
            placeholder="Tu contraseña"
            name="password"
            type="password"
            autoComplete="current-password"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
          />
          {errors.password && touched.password && <span className="gd-login-error">{errors.password}</span>}
          {!errors.password && loginError && <span className="gd-login-error">{loginError}</span>}

          <button type="submit" className="ContinueForm gd-login-primary">
            Iniciar sesión
          </button>
          <button type="button" className="gd-login-link gd-login-link-small" onClick={() => setOptionView("forgot")}>
            Olvidé mi contraseña
          </button>
        </form>
      )}
    </Formik>
  );

  const googleButton = (
    <GoogleLogin
      clientId="780265444499-oi0sa86lg23lsr1kqf43qmuqbh6sog0k.apps.googleusercontent.com"
      onSuccess={responseGoogle}
      onFailure={responseGoogleFail}
      cookiePolicy={"single_host_origin"}
      scope="profile"
      render={(renderProps) => (
        <button type="button" className="gd-login-google" onClick={renderProps.onClick} disabled={renderProps.disabled}>
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.6 5.4 2.7 13.3l7.9 6.1C12.5 13.6 17.8 9.5 24 9.5z" />
            <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.7 6c4.5-4.2 6.9-10.3 6.9-17.7z" />
            <path fill="#FBBC05" d="M10.6 28.6c-.5-1.4-.8-3-.8-4.6s.3-3.2.8-4.6l-7.9-6.1C1 16.6 0 20.2 0 24s1 7.4 2.7 10.7l7.9-6.1z" />
            <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.7-6c-2.2 1.5-5 2.3-8.2 2.3-6.2 0-11.5-4.1-13.4-9.9l-7.9 6.1C6.6 42.6 14.6 48 24 48z" />
          </svg>
          Continuar con Google
        </button>
      )}
    />
  );

  return (
    <>
      <Header documento={documento} position={"center"} />

      <Recaptcha
        ref={(e) => (recaptchaInstance = e)}
        sitekey="6Ld-B88ZAAAAAMAOXt8hzUPxeQq5qIRCy8xfmgVx"
        size="invisible"
        verifyCallback={verifyCallback}
        onloadCallback={() => console.log("carga...")}
      />

      <Grid id="center-form" container direction="row" justify="center" alignItems="center">
        <Grid item xl={4} md={6} className="gd-login-col">
          <Card className="mb-5 card-box card-box-border-bottom border-success justForm gd-login">
            <CardContent className="gd-login-content">
              {optionView === "register" && (
                <>
                  <button
                    type="button"
                    className="gd-login-link"
                    onClick={() => setOptionView(allowGuest ? "login" : "password")}
                  >
                    ← Volver
                  </button>
                  <Signup />
                </>
              )}

              {optionView === "forgot" && (
                <>
                  <button type="button" className="gd-login-link" onClick={() => setOptionView("password")}>
                    ← Volver
                  </button>
                  <Forgot />
                </>
              )}

              {(optionView === "login" || optionView === "password") && (
                <>
                  {allowGuest ? (
                    <>
                      <h2 className="gd-login-title">¿A qué correo te enviamos el documento?</h2>
                      <p className="gd-login-sub">
                        Ahí te llegará el documento y el enlace para retomar el trámite cuando quieras.
                      </p>
                    </>
                  ) : (
                    <>
                      <h2 className="gd-login-title">Inicia sesión para continuar</h2>
                      <p className="gd-login-sub">
                        Para continuar con tu trámite, debemos tener un correo donde enviar tu información.
                      </p>
                    </>
                  )}

                  {allowGuest && optionView === "login" && (
                    <>
                      <form className="gd-login-form" onSubmit={continueAsGuest}>
                        <label className="gd-login-label" htmlFor="gd-guest-email">
                          Tu correo
                        </label>
                        <TextField
                          id="gd-guest-email"
                          className="input_sign"
                          variant="outlined"
                          size="small"
                          fullWidth
                          type="email"
                          autoComplete="email"
                          placeholder="tu@correo.cl"
                          value={guestEmail}
                          onChange={(e) => setGuestEmail(e.target.value)}
                        />
                        {guestError && <span className="gd-login-error">{guestError}</span>}
                        <button type="submit" className="ContinueForm gd-login-primary">
                          Continuar sin crear cuenta
                        </button>
                      </form>

                      <div className="gd-login-sep">
                        <span>o si ya tienes cuenta</span>
                      </div>

                      {googleButton}
                      <button type="button" className="gd-login-secondary" onClick={() => setOptionView("password")}>
                        Iniciar sesión con correo y contraseña
                      </button>
                    </>
                  )}

                  {optionView === "password" && (
                    <>
                      {!allowGuest && (
                        <>
                          {googleButton}
                          <div className="gd-login-sep">
                            <span>o con tu correo</span>
                          </div>
                        </>
                      )}
                      {passwordForm}
                      {allowGuest && (
                        <button type="button" className="gd-login-link" onClick={() => setOptionView("login")}>
                          ← Prefiero continuar sin cuenta
                        </button>
                      )}
                    </>
                  )}

                  <p className="gd-login-foot">
                    ¿No tienes cuenta y la quieres crear?{" "}
                    <button type="button" className="gd-login-link" onClick={() => setOptionView("register")}>
                      Crear cuenta
                    </button>
                  </p>
                </>
              )}

              {canGoBack && (
                <div className="gd-login-back">
                  <button type="button" className="ContinueForm" onClick={handleBack}>
                    Retroceder
                  </button>
                </div>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
